export const WORKING_ORDER = {
    HEADER_CART: "header-cart",
    SPINNER: "spinner",
    CART_ITEM_COUNT: "cart-item-count",
    ORDER_REVIEW_TAB: "order-review-tab",
    LOADING_ORDER: "loading-order",
    DOORS_SELECT: {
        SEARCH: "doors-select-search",
        NO_RESULTS_MESSAGE: "doors-select-no-results-message",
        SELECT_ALL: "doors-select-select-all",
        SELECTED_LOCATIONS: "doors-select-selected-locations",
        SELECTION_NAME: "doors-selection-name",
        SELECTION_TOOLTIP: "doors-selection-tooltip",
        SELECTION_WARNING_TOOLTIP: "selection-warning-tooltip",
        SELECTION_WARNING_ICON: "selection-warning-icon",
        SIZE_LOCATION_NAME: "size-location-name",
        DRAG_HANDLE: "drag-handle",
    },
    SELECTION_REMOVE_CONFIRMATION: {
        ROOT: "selection-remove-confirmation-root",
        MESSAGE: "selection-remove-confirmation-message",
        TITLE: "selection-remove-confirmation-title",
    },
    PRODUCT_TAB: {
        ADD_SIZING: "add-sizing",
        ORDER_BY_LOCATION: "order-by-location",
        SIZE_CELL_INPUT: "size-cell-input",
        LINE_ITEM: {
            PRODUCT_NAME: "product-name",
            ORIGINAL_WHOLESALE_PRICE: "original-wholesale-price",
            ADJUSTED_WHOLESALE_PRICE: "adjusted-wholesale-price",
            DISCOUNTED_WHOLESALE_PRICE: "discounted-wholesale-price",
        },
    },
    REVIEW_TAB: {
        SPLIT_GROUP: {
            ADDRESS_SHIP_TO: "split_group_shipping_address_ship_to_block",
            ADDRESS_DETAILS: "split_group_shipping_address_details",
            ADDRESS_DESCRIPTION: "split_group_shipping_address_description",
        },
        SHIPPING: {
            OVERRIDE_SHIPPING_TOGGLE: "override_shipping-toggle",
            OVERRIDE_SHIPPING_TOGGLE_DISABLED: "override_shipping-toggle-disabled",
            OVERRIDE_SHIPPING_FEATURE: "override_shipping-feature",
            SET_OTHER_SHIPPING_METHOD_FEATURE: "set_other_shipping_method_feature",
            SET_OTHER_SHIPPING_METHOD_FEATURE_DISABLED: "set_other_shipping_method_feature-disabled",
            SHIPPING_RATE_SELECTOR_OPTION_OTHER: "shipping_rate_selector_option-Other",
            SHIPPING_AMOUNT: "shipping_amount",
            SHIPPING_TYPE: "shipping_type_input",
            SHIPPING_REVIEW_TOTAL: "shipping-review-total",
        },
        SURCHARGE_LABEL: "order-totals-surcharge-label",
        SURCHARGE_TOTAL_VALUE: "order-totals-surcharge-value",
        ORDER_SUBTOTAL_VALUE: "order-totals-subtotal-label",
        ORDER_TOTAL_VALUE: "order-totals-block-value",
    },
    FOOTER: {
        SAVE_AS_DRAFT: "save-as-draft",
    },
    DRAFT: {
        DRAFT_ORDER_NAME: "draft-order-name",
        SAVE_DRAFT_ORDER: "save-draft-order",
    },
    BANNERS: {
        SECTION: "working-order-banners-section",
        SECTION_TITLE: "working-order-banner-section-title",
        BANNER: "working-order-banner",
        BANNER_DESCRIPTION: "working-order-banner-description",
    },
    LINE_ITEM_RESULTS_SECTION: {
        SECTION: "line-item-results-section",
        GROUP: "line-item-results-group",
        GROUP_SECTION: "line-item-results-group-section",
        GROUP_SECTION_TITLE: "line-item-results-group-section-title",
        GROUP_SECTION_ITEMS: "line-item-results-group-section-items",
        GROUP_SECTION_ITEM_NAME: "line-item-results-group-section-items-title",
        GROUP_SECTION_ITEM_VALUE: "line-item-results-group-section-items-value",
    },
    NOTIFICATIONS: {
        OK_BUTTON: "working-order-notification-ok-button",
        ERROR: "working-order-notification-error",
        ERRORS: ".error-container p",
    },
};
